import type { BankFormat } from "./bank-tally-export-form";
import { BankParseError, type BankParseResult } from "./bank-statement-types";
import { parseHdfcStatementFile } from "./parse-hdfc-statement";
import { parsePnbStatementFile } from "./parse-pnb-statement";

export { BankParseError } from "./bank-statement-types";
export type { BankCreditTxn, BankParseResult, BankSkippedRow } from "./bank-statement-types";
export { BANK_SKIP_REASON_DEBIT } from "./bank-statement-types";

/** Download filename prefix for `exportToTallyExcel`. */
export function bankTallyFilenamePrefix(format: BankFormat): string {
  switch (format) {
    case "PNB":
      return "bank-tally-pnb";
    case "HDFC":
      return "bank-tally-hdfc";
    default: {
      const _exhaustive: never = format;
      return _exhaustive;
    }
  }
}

export async function parseBankStatementFile(
  format: BankFormat,
  file: File
): Promise<BankParseResult> {
  switch (format) {
    case "PNB":
      return parsePnbStatementFile(file);
    case "HDFC":
      return parseHdfcStatementFile(file);
    default: {
      const _exhaustive: never = format;
      throw new BankParseError(`Unsupported bank format: ${String(_exhaustive)}`);
    }
  }
}
